import zh from './lib/zh.js'
import en from './lib/en.js'
export default {
  en: Object.assign(en, en),
  zh: Object.assign(zh, zh)
}
